import { Trans } from '@lingui/react/macro';
import { PropsWithChildren, useState, useEffect } from 'react';

import { ExternalLink } from 'client-web-sdk';

export default function PreloadErrorHandler({ children }: PropsWithChildren<{}>) {
  const [preloadSyntaxError, setPreloadSyntaxError] = useState(false);

  useEffect(() => {
    const handlePreloadError = (e: VitePreloadErrorEvent): void => {
      // payload contains the original error object
      const err = e.payload;
      if (err instanceof SyntaxError) {
        setPreloadSyntaxError(true);
        e.preventDefault();
      }
    };

    window.addEventListener('vite:preloadError', handlePreloadError);
    return () => {
      window.removeEventListener('vite:preloadError', handlePreloadError);
    };
  });

  return preloadSyntaxError ?
      // Re-uses styles for the global fallback, see index.html
      <div id="fallback">
        <Trans>Your browser is out of date. Please update your browser to use heylogin.</Trans>{' '}
        <ExternalLink href="https://browsehappy.com/?locale=en">
          <Trans>How to update?</Trans>
        </ExternalLink>
      </div>
    : children;
}
